import * as types from "./mutation-types";

const mutations = {
  [types.CHANGE_CURRENT_OPT](state, optNum) {
    state.currentOpt = optNum;
  },
  toggleMarked(state, arg) {
    if (state.isMarked == true) {
      state.isMarked = false;
    } else {
      state.isMarked = true;
    }
  },
  togglePointPanel(state, arg) {
    if (state.isPointPanel == true) {
      state.isPointPanel = false;
    } else {
      state.isPointPanel = true;
    }
  },
  bindTime(state, arg) {
    state.selectTime = arg;
  },
  changeTask(state, arg) {
    if (arg[0] === "type") {
      state.taskType = arg[1];
    } else if (arg[0] === "tool") {
      state.taskTool = arg[1];
    }
  },
};

export default mutations;
